import {
	isSinchConfiguredAsCommonWhatsappProvider,
	isWhatsAppCloudConfiguredAsProvider,
} from 'store/App/User/selectors';
import { RootState } from 'store/rootReducer';

export const publishedBroadcastList = (state: RootState) => state.Broadcast.published;

export const broadcastStatistics = (state: RootState) => state.Broadcast.statistics.data;

export const scheduledBroadcastList = (state: RootState) => state.Broadcast.scheduled;

export const draftBroadcastList = (state: RootState) => state.Broadcast.draft;

export const publishedFilters = (state: RootState) => state.Broadcast.published.filters;

export const publishedSort = (state: RootState) => state.Broadcast.published.sort;

export const numberMessageLimit = (state: RootState) => state.Broadcast.messageLimit;

export const messageTemplatesSelector = (state: RootState) => state.Broadcast.messageTemplates;

export const selectWhatsappBusinessId = (state: RootState) => state.Bot.data.whatsapp_business_id ?? '';

export const selectWhatsappCloudAccessToken = (state: RootState) => state.Bot.data.nexmo_private_key_contents ?? '';

export const selectWhatsappApiKey = (state: RootState) => state.Bot.data.nexmo_application_id;

export const providerSelector = (state: RootState) => state.Bot.data.provider_configured;

export const selectEffectiveWhatsappBusinessId = (state: RootState) => {
	if (isSinchConfiguredAsCommonWhatsappProvider(state)) {
		return state.Bot.data.common_whatsapp_provider_config?.WABA_ID || '';
	}

	return state.Bot.data.whatsapp_business_id ?? '';
};

export const selectEffectiveWhatsappApiKey = (state: RootState) => {
	if (isSinchConfiguredAsCommonWhatsappProvider(state)) {
		return state.Bot.data.common_whatsapp_provider_config?.BEARER_TOKEN || '';
	}
	if (isWhatsAppCloudConfiguredAsProvider(state)) {
		return state.Bot.data.nexmo_private_key_contents ?? '';
	}

	return state.Bot.data.nexmo_application_id;
};
